"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Async function to sleep
 * @param ms Time to wait in miliseconds
 */
function sleep(ms) {
    // Create a new promise
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
exports.default = sleep;
